<template>
  <div class="layout-px-spacing" style="padding: 15px 0 0 2.5rem">
    <div class="d-flex justify-content-between">
      <div class="filter-wrap">
        <div class="filter-item">
          <h6 class="item-icon icon1">创意描述</h6>
          <el-input type="textarea" :rows="5" placeholder="请输入要生成的商品背景描述" v-model="prompt" show-word-limit :maxlength="500"></el-input>
        </div>
        <div class="filter-item mt-3">
          <h6 class="item-icon icon2">参数设置</h6>
          <div class="options-wrap d-flex justify-content-between align-items-center my-4">
            <div v-for="item in 7" :key="item" :class="['option', `option${item}`, { checked: checked == item }, { disabled: item != 1 }]" @click="selectRatio(item)"></div>
          </div>
          <div class="num-wrap mt-4 pt-4">
            <div>生成数量: {{ count }}张</div>
            <el-slider v-model="count" show-stops :min="1" :max="10" :step="1"></el-slider>
          </div>
        </div>
        <!-- <div class="d-flex justify-content-between mt-3">
          <div class="slider-wrap">
            <h6>宽度</h6>
            <el-slider v-model="width" show-input :show-input-controls="false" :min="1" :max="2048"></el-slider>
          </div>
          <div class="slider-wrap">
            <h6>高度</h6>
            <el-slider v-model="height" show-input :show-input-controls="false" :min="1" :max="2048"></el-slider>
          </div>
        </div> -->
        <!-- <div class="d-flex justify-content-between mt-3">
          <div class="slider-wrap">
            <h6>生成批次</h6>
            <el-slider v-model="batch" show-input :show-input-controls="false" :min="1"></el-slider>
          </div>
          <div class="slider-wrap">
            <h6>每批数量</h6>
            <el-slider v-model="count" show-input :show-input-controls="false" :min="1" :max="8"></el-slider>
          </div>
        </div> -->
        <!-- <div class="d-flex justify-content-between mt-3">
          <div class="slider-wrap">
            <h6>采样迭代步数</h6>
            <el-slider v-model="step" show-input :show-input-controls="false" :min="1"></el-slider>
          </div>
          <div class="slider-wrap">
            <h6>提示词相关性</h6>
            <el-slider v-model="relative" show-input :show-input-controls="false" :min="1" :max="30"></el-slider>
          </div>
        </div> -->
        <!-- <div class="mt-3">
          <h6>随机种子</h6>
          <el-input-number v-model="seed" controls-position="right" :precision="0"></el-input-number>
          <el-button class="ml-2" style="width: 88px" @click="seed = -1">随机</el-button>
        </div> -->
        <el-button class="generate-button" type="primary" style="width: 100%" :loading="submitting" @click="generateImg">立即生成（消耗5积分）</el-button>
      </div>
      <div class="content-wrap d-flex justify-content-center">
        <div class="loading-wrap d-flex flex-column justify-content-center align-items-center" v-if="uploading">
          <img src="@/assets/images/icon/clock.svg" alt="" style="height: 38px" />
          <div class="loading-text mt-3">稍等片刻，完美即将呈现</div>
          <div class="countdown-text mt-2">
            预计将等待 <span style="color: #9eff0c">{{ countdown }}s</span>
          </div>
          <el-progress class="my-3" :text-inside="true" :stroke-width="10" :percentage="Math.floor(progress)" style="width: 300px"></el-progress>
          <div class="loading-text" style="color: #88929f">{{ textList[textIndex] }}</div>
        </div>
        <div class="fabric-wrap" v-if="showFabric">
          <canvas id="canvas" width="512" height="512"></canvas>
          <div class="mask d-flex flex-column justify-content-center align-items-center" v-if="submitting">
            <!-- <img src="@/assets/images/icon/loading.gif" alt="" /> -->
            <div class="countdown-text">
              预计将等待 <span style="color: #9eff0c">{{ countdown }}s</span>
            </div>
            <div class="loading-text mt-3">{{ textList2[textIndex2] }}</div>
          </div>
          <img v-if="showPreview" class="preview-img" :src="previewImgUrl" />
        </div>
        <el-upload v-else class="upload-wrap" action="#" accept=".png,.jpg" :auto-upload="false" drag :on-change="onImageChange">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <div v-if="showPreview" class="back-btn" @click="backto">返回</div>
      </div>
      <div class="result-wrap">
        <!-- <div v-show="!submitting" class="justify-content-between" :class="{ 'd-flex': !submitting }" style="height: 100%"> -->
        <!-- <div class="preview-wrap d-flex justify-content-center align-items-center">
            <img v-show="!batchImgList[0]" :src="allImgList[activeIndex]" alt="" />
            <img v-if="blurFlag" :src="batchImgList[0]" alt="" id="preview-img" @load="imgLoadFinish" style="display: none" />
            <canvas v-if="blurFlag" v-show="batchImgList[0]" id="canvas" :style="`width:${canvasWidth}px;height:${canvasHeight}px`"></canvas>
          </div> -->
        <div class="stage-wrap">
          <div v-if="!allImgList.length">
            <div class="thumbnail-wrap d-flex justify-content-center align-items-center" style="background: #0d1116; color: #88929f; border-radius: 10px">
              <div style="transform: translateY(-50px); font-size: 12px">暂无作品</div>
            </div>
          </div>
          <div v-for="(item, index) in allImgList" :key="index">
            <div class="thumbnail-wrap mb-2">
              <div class="thumbnail d-flex justify-content-center align-items-center" :class="{ checked: index == activeIndex }">
                <img :src="item.sourceUrl ? item.sourceUrl : failImg" alt="" @click="changeImg(index)" />
              </div>
              <div class="download" @click="download(item.sourceUrl)"></div>
              <!-- <div class="remove" @click="remove(item, index)"></div> -->
            </div>
          </div>
        </div>
        <!-- </div> -->
        <!-- <el-button v-show="allImgList.length" class="save-btn" type="primary">保存</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { deletesProductImage } from '@/service';
import { postForm } from '@/service/request.js';
import { fetchEventSourceWithHeaders } from '@/service/eventSource';
import { downloadImage } from '@/utils/util';
import deleteicon from '@/assets/images/icon/icon3.png';
import failImg from '@/assets/images/icon/fail-bg.svg';

// const isLocal = process.env.NODE_ENV === 'development';
let previewImg, canvas, ctx;
const fabric = window.fabric;
const fabricRatio = 2;

// 渲染图标的方法
function renderIcon(image, initialAngle) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    let size = 20;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle + initialAngle));
    ctx.drawImage(image, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}
export default {
  data() {
    return {
      failImg,
      modelList: [],
      model: '',
      prompt: '',
      reversePrompt:
        '((nsfw)),((ugly))),(((duplicate))),((morbid)),((mutilated)),(((tranny))),(((trans))),((trannsexual))),(((mutation))),(((deformed)))(((long neck))),((bad anatomy))(((bad proportions))),(((extra arms))),(((extra legs))), (((disfigured))),((more than 2 nipples))),malformed,mutated,(hermaphrodite),((extra limbs)).((missing arms)).((missing legs)).((poorly drawn hands))((poorty drawn face)),(mutation,poorly drawn :1.2),(long body :1.3).multiple breasts,cloned face,gross proportions, mutated hands,bad hands,bad feet,long neck,missing limb,(malformed limbs),malformed hands,(fused fingers).(too many fingers),extra fingers,missing fingers,extra digit,fewer digits,(mutated hands and fingers :1.5),low res,text,error,cropped,worst quality,low quality,normal quality,jpeg artifacts,signature,watermark,username,blurry,text font ui,futa,yaoi,',
      width: 1024,
      height: 1024,
      batch: 1,
      count: 1,
      step: 20,
      relative: 7,
      seed: -1,
      allImgList: [],
      batchImgList: [],
      activeIndex: 0,
      submitting: false,
      progress: 0,
      animation: '',
      blurFlag: true,
      canvasWidth: '',
      canvasHeight: '',
      checked: 1,
      productFile: '',
      canvas: '',
      uploading: false,
      textList: ['背景正在悄悄溜走，请稍等片刻', '正在为你慢慢剥离不需要的部分，马上就好了!', '我正在像艺术家一样为你雕刻图片的每一个细节!'],
      textIndex: 0,
      textList2: ['AI正在精心绘制图片，请耐心等待哦~', '所有生成的图片都会经过 AI审核，层层筛选', '一次生图不满意的话，建议再生一次', '时间太久等不及，出去逛逛，稍后在生成记录内查看哦~'],
      textIndex2: 0,
      loadProgress: 0,
      targetObject: '',
      showPreview: false,
      previewImgUrl: '',
      countdown: 30,
      startTime: '',
      productUrl: '',
      sourceId: '',
    };
  },
  computed: {
    ...mapGetters({
      account: 'accountInfo/account',
    }),
    showFabric() {
      const isshow = !!this.productFile;
      if (isshow) {
        this.$nextTick(() => {
          this.renderCanvas();
        });
      }
      return isshow || this.$route.params.image;
    },
  },
  beforeCreate() {
    // if (!window.localStorage.getItem('islogin')) {
    //   this.$router.replace('/auth/login');
    // }
  },
  mounted() {
    // console.log(this.$route);
    if (this.$route.params.image) {
      this.renderCanvas(this.$route.params.image, this.$route.params.id);
    }
    // if (!this.blurFlag) return;
    // previewImg = document.querySelector('#preview-img');
    // canvas = document.querySelector('#canvas');
    // ctx = canvas.getContext('2d');
    // clientWidth = document.querySelector('.preview-wrap').clientWidth;
    // clientHeight = document.querySelector('.preview-wrap').clientHeight;
  },
  methods: {
    ...mapActions({
      setScoreAsync: 'score/setScoreAsync',
    }),
    selectRatio(index) {
      console.log(index);

      this.checked = 1;
    },
    onImageChange(file) {
      let { name, size } = file || {};
      name = name.toLowerCase();
      if (!name.endsWith('.png') && !name.endsWith('.jpg')) {
        this.$message.warning('仅支持png、jpg格式');
        return false;
      }
      if (size > 10 * 1024 * 1024) {
        this.$message.error('最大支持10M');
        return false;
      }
      this.uploading = true;
      this.startTime = Date.now();
      this.countdown = 30;
      this.startAnimation();
      this.productFile = [file];
      // this.productUrl = URL.createObjectURL(file.raw);
    },
    renderCanvas(imageUrl, sourceId) {
      this.canvas = new fabric.Canvas('canvas');
      // ...这里可以写canvas对象的一些配置，后面将会介绍

      // 如果<canvas>标签没设置宽高，可以通过js动态设置
      this.canvas.setWidth(512);
      this.canvas.setHeight(512);
      fabric.Object.prototype.transparentCorners = false;
      fabric.Object.prototype.controls.mtr.visible = false;
      fabric.Object.prototype.controls.mt.visible = false;
      fabric.Object.prototype.controls.ml.visible = false;
      fabric.Object.prototype.controls.mr.visible = false;
      fabric.Object.prototype.controls.mb.visible = false;

      // 修改控制点的形状，默认为`rect`矩形，可选的值还有`circle`圆形
      fabric.Object.prototype.cornerStyle = 'circle';
      // 修改控制点的填充色为白色
      fabric.Object.prototype.cornerColor = 'white';
      // 修改控制点的大小为10px
      fabric.Object.prototype.cornerSize = 10;
      //将控制线默认的浅蓝色改为 #dc143c，
      fabric.Object.prototype.borderColor = '#9EFF0C';

      // 垃圾桶图标的下载链接
      const deletecallback = (img, isError) => {
        // console.log(img);
        if (!isError) {
          fabric.Object.prototype.controls.delete = new fabric.Control({
            // x和y设置该控制点和第二列中间的控制点重合
            x: 0,
            y: -0.5,
            // offsetX和offsetY设置该控制点在水平和竖直两个方向上
            // 偏移的距离（单位px）
            offsetY: -20,
            // 光标移动到该控制点时变为一个手的图标
            cursorStyle: 'pointer',
            // 自定义的值，可忽略
            actionName: 'delete',
            // 设置当点击了该控制点，鼠标弹起是执行的动作处理方法
            mouseUpHandler: () => this.deleteObject(),
            //渲染图标
            render: renderIcon(img._element, 0),
            cornerSize: 39,
          });
        }
      };
      fabric.Image.fromURL(deleteicon, deletecallback);

      const self = this;
      this.canvas.on('mouse:down', function (options) {
        console.log(options);
        if (options.target) {
          self.targetObject = options.target;
        }
        // if (!options.target) return;
        // if (options.target.type === 'image') {
        //   // _this.selectedImg = options.target;
        //   return;
        // } else {
        //   const { fill, fontSize, opacity, fontFamily, charSpacing } = options.target;
        //   _this.word = {
        //     fill,
        //     fontFamily,
        //     fontSize,
        //     opacity,
        //     charSpacing,
        //   };
        // }
      });

      if (imageUrl) {
        this.productUrl = imageUrl;
        this.sourceId = sourceId;
        this.loadImage();
      } else {
        this.uploadImage();
      }
    },
    uploadImage() {
      let formdata = new FormData();
      formdata.append('file', this.productFile[0].raw);
      formdata.append('sourceType', 0);
      postForm(`/api/source_material/add`, formdata)
        .then((res) => {
          this.productUrl = res.data.sourceUrl;
          this.sourceId = res.data.id;
          this.loadImage();
        })
        .finally(() => {
          window.cancelAnimationFrame(this.animation);
        });

      // window.setTimeout(() => {
      //   this.loadImage();
      // }, 3000);
    },
    loadImage() {
      const imgEl = document.createElement('img');
      const self = this;
      imgEl.onload = function () {
        // console.log(imgEl.width, imgEl.height);
        const total = 512;
        let width = imgEl.width;
        let height = imgEl.height;
        const ratio = width / height;
        let scale = 0.5,
          left = 0,
          top = 0;
        if (total < width || total < height) {
          if (ratio >= 1) {
            scale = total / width / fabricRatio;
          } else {
            scale = total / height / fabricRatio;
          }
          width *= scale;
          height *= scale;
        }
        left = (total - width) / 2;
        top = (total - height) / 2;

        self.targetObject = {
          width: width / scale,
          height: height / scale,
          left,
          top,
          scaleX: scale,
          scaleY: scale,
        };
        // console.log(self.targetObject);

        const img = new fabric.Image(imgEl, { ...self.targetObject });
        self.canvas.add(img);
        self.uploading = false;
      };
      imgEl.src = this.productUrl;
      // document.body.appendChild(imgEl);
    },
    deleteObject() {
      // 获取画布当前选中的对象
      let activeObject = this.canvas.getActiveObject();
      if (activeObject) {
        this.canvas.remove(activeObject);
        this.canvas.renderAll();
        this.resetUpload();
      }
    },
    resetUpload() {
      this.productFile = '';
      this.progress = 0;
      this.loadProgress = 0;
      this.targetObject = '';
    },
    generateImg() {
      // console.log(this.targetObject);

      if (!this.prompt.trim()) {
        this.$message.warning('请填写文字描述');
        return;
      }
      if (!this.checked) {
        this.$message.warning('请选择图片比例');
        return;
      }
      if (!this.targetObject) {
        this.$message.warning('请上传商品图片');
        return;
      }
      const { width, height, left, top, scaleX: scale } = this.targetObject;
      // console.log(width, height, left, top, scale);
      const pointLeft = left + (width * scale) / 2;
      const pointTop = top + (height * scale) / 2;
      // console.log(pointLeft, pointTop);

      this.submitting = true;
      this.startTime = Date.now();
      this.countdown = this.count * 90;
      this.startCountdownAnimation();
      // const [w, h] = this.calcSize(clientWidth, clientHeight, this.width, this.height);
      // this.canvasWidth = w;
      // this.canvasHeight = h;
      const params = {
        prompt: this.prompt.trim(),
        // width: this.width,
        // height: this.height,
        sourceId: this.sourceId,
        scale: '1:1',
        x_m: Math.floor((pointLeft / this.width) * fabricRatio * 100),
        y_m: Math.floor((pointTop / this.height) * fabricRatio * 100),
        degree: scale * fabricRatio,
        count: this.count,
      };
      postForm(`/api/gc/generate-image-task`, params).then((res) => {
        // console.log(res);
        // this.previewImgUrl = res.data.infos[0].sourceUrl;
        // this.batchImgList = res.data.infos;
        const headers = new Headers();
        headers.append('Authorization', localStorage.getItem('authToken'));

        fetchEventSourceWithHeaders(`/api/gc/generate-image/subscribe?requestId=${res.data.requestId}&count=${this.count}`, headers, {
          messageCallback: this.getImageMessage,
          completeCallback: this.resetGenerate,
        });
      });
    },
    parseString(str) {
      // 定义用于匹配 taskListId 和 imageUrl 的正则表达式
      const taskListIdRegex = /"taskListId"\s*:\s*(\d+)/;
      const imageUrlRegex = /"imageUrl"\s*:\s*"([^"]+)"/;

      // 使用正则表达式匹配并提取值
      const taskListIdMatch = str.match(taskListIdRegex);
      const imageUrlMatch = str.match(imageUrlRegex);

      // 检查是否成功匹配
      if (!taskListIdMatch || !imageUrlMatch) {
        return;
      }

      // 返回提取的结果
      return {
        taskListId: parseInt(taskListIdMatch[1], 10),
        imageUrl: imageUrlMatch[1],
      };
    },
    getImageMessage(text) {
      // console.log(text);
      const result = this.parseString(text);
      if (result) {
        const { imageUrl: sourceUrl, taskListId } = result;
        this.previewImgUrl = sourceUrl;
        this.allImgList.unshift({ sourceUrl, taskListId });
        this.activeIndex = 0;
        // this.batchImgList = res.data.infos;
      }
    },
    resetGenerate() {
      this.submitting = false;
      this.endAnimation();
      window.cancelAnimationFrame(this.animation);
      this.setScoreAsync();
      this.loadProgress = 0;
    },
    startCountdownAnimation() {
      this.startCountdown(this.count * 90);
      this.playSubtitles('textIndex2', 'textList2');
      this.animation = window.requestAnimationFrame(this.startCountdownAnimation);
    },
    startCountdown(total) {
      if (this.countdown > 1) {
        const left = Date.now() - this.startTime;
        this.countdown = total - Math.floor(left / 1000);
      }
    },
    playSubtitles(indexName, listName, step = 1, max = 150) {
      // 增加进度
      this.loadProgress += step;
      // 如果进度达到最大值，则重置进度并更新文本索引
      if (this.loadProgress >= max) {
        this.loadProgress = 0;
        this[indexName] = this[indexName] < this[listName].length - 1 ? this[indexName] + 1 : 0;
      }
    },
    startAnimation() {
      this.startCountdown(30);
      this.progress < 99 && (this.progress += 0.05);
      // console.log(this.progress);
      this.playSubtitles('textIndex', 'textList');
      this.animation = window.requestAnimationFrame(this.startAnimation);
    },
    endAnimation() {
      this.allImgList = [...this.batchImgList, ...this.allImgList];
      this.batchImgList = [];
      this.activeIndex = 0;
      this.showPreview = true;
    },
    backto() {
      this.resetUpload();
      this.showPreview = false;
    },
    changeImg(index) {
      this.activeIndex = index;
      this.previewImgUrl = this.allImgList[index].sourceUrl;
    },
    calcSize(containerWidth, containerHeight, contentWidth, contentHeight) {
      if (containerWidth > contentWidth && containerHeight > contentHeight) {
        return [contentWidth, contentHeight];
      }
      let radio = Math.max(contentWidth / containerWidth, contentHeight / containerHeight);
      radio = Number(radio.toFixed(2));
      return [parseInt(contentWidth / radio), parseInt(contentHeight / radio)];
    },
    matchImgSizeToCanvas(imgElem) {
      const [w, h] = this.calcSize(this.canvasWidth, this.canvasHeight, imgElem.width, imgElem.height);
      imgElem.width = w;
      imgElem.height = h;
    },
    imgLoadFinish() {
      if (!this.blurFlag) return;
      this.cleanCanvas();
      this.matchImgSizeToCanvas(previewImg);
      this.run();
    },
    cleanCanvas() {
      ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
    },
    run() {
      let ct = [50, 20, 10, 1];
      let index = 0;
      let timer = setInterval(() => {
        const blur = ct[index++];
        if (index == 4) {
          clearInterval(timer);
          this.endAnimation();
        }
        canvas.width = parseInt(this.canvasWidth / blur);
        canvas.height = parseInt(this.canvasHeight / blur);
        console.log(this.canvasWidth / blur);
        console.log(this.canvasHeight / blur);
        console.log(previewImg.width / blur);
        console.log(previewImg.height / blur);
        ctx.drawImage(previewImg, 0, 0, parseInt(previewImg.width / blur), parseInt(previewImg.height / blur));
      }, 1000);
    },
    download(url) {
      const index = url.indexOf('kiwi-aigc-images');
      // console.log(url.slice(index));
      downloadImage(url.slice(index - 1));
    },
    remove(item, index) {
      // console.log(item);
      this.allImgList.splice(index, 1);
      deletesProductImage(item.taskListId);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-slider__runway.show-input {
    width: 75%;
  }
  .el-slider__input.el-input-number--small {
    width: 60px;
    margin-top: 5px;
    // pointer-events: none;
    .el-input__inner {
      height: 24px;
      line-height: 24px;
    }
  }
  .el-textarea__inner {
    resize: none;
    background-color: #0d1116;
    border: 1px solid #0d1116;
    border-radius: 12px;
    color: #fff;
  }
  .el-textarea__inner::placeholder {
    font-size: 12px;
  }
  .el-textarea__inner:focus {
    border-color: #9eff0c;
  }

  .filter-wrap .el-input__count {
    background-color: #0d1116;
    color: #88929f;
  }
  .el-slider__bar {
    background-color: #9eff0c;
  }
  .el-slider__runway {
    background-color: #333a45;
  }
  .el-slider__stop {
    width: 10px;
    height: 10px;
    background-color: #333a45;
    transform: translate(-50%, -20%);
  }
  .el-slider__button {
    background-color: #9eff0c;
    border-color: transparent;
  }
  .el-progress-bar__innerText {
    display: none;
  }
  .el-progress-bar__outer {
    background-color: #88929f !important;
  }
  .el-progress-bar__inner {
    background: linear-gradient(192deg, #9eff0c 0%, #43d1a7 100%);
  }
}
.filter-wrap {
  position: relative;
  width: 20%;
  .filter-item {
    padding: 16px;
    border-radius: 12px;
    background: linear-gradient(180deg, #181f26 0%, #222631 100%);
    h6 {
      margin-bottom: 16px;
      color: #ffffff;
      font-size: 14px;
    }
    .item-icon {
      padding-left: 25px;
      background-repeat: no-repeat;
      background-position: left center;
      background-size: 15px;
      &.icon1 {
        background-image: url('~@/assets/images/icon/icon1.png');
      }
      &.icon2 {
        background-image: url('~@/assets/images/icon/icon2.png');
      }
    }
    .options-wrap {
      .option {
        position: relative;
        border-radius: 4px;
        border: 1px solid #ffffff;
        cursor: pointer;
        &::before {
          content: '';
          position: absolute;
          top: 22px;
          color: #fff;
          font-size: 12px;
        }
        &.checked {
          border: 1px solid #9eff0c;
          &::before {
            color: #9eff0c;
          }
        }
        &.disabled {
          border-color: #333a45;
          cursor: default;
          &::before {
            color: #333a45;
          }
        }
      }
      .option1 {
        width: 20px;
        height: 20px;
        &::before {
          content: '1:1';
        }
      }
      .option2 {
        width: 20px;
        height: 10px;
        &::before {
          content: '16:9';
          top: 17px;
          left: -3px;
        }
      }
      .option3 {
        width: 10px;
        height: 20px;
        &::before {
          content: '9:16';
          left: -8px;
        }
      }
      .option4 {
        width: 20px;
        height: 16px;
        &::before {
          content: '4:3';
          top: 20px;
        }
      }
      .option5 {
        width: 20px;
        height: 12px;
        &::before {
          content: '3:2';
          top: 18px;
        }
      }
      .option6 {
        width: 12px;
        height: 20px;
        &::before {
          content: '2:3';
          left: -4px;
        }
      }
      .option7 {
        width: 16px;
        height: 20px;
        &::before {
          content: '3:4';
        }
      }
    }
    .num-wrap {
      color: #88929f;
    }
  }
  .slider-wrap {
    width: 48%;
  }
  .generate-button {
    position: absolute;
    bottom: 0;
    left: 5%;
    width: 90% !important;
    background: linear-gradient(192deg, #9eff0c 0%, #43d1a7 100%);
    border-radius: 20px !important;
    color: #0d1116 !important;
  }
}
.content-wrap {
  position: relative;
  width: 35%;
  transform: scale(1.1);
  transform-origin: top;
  .bg {
    position: absolute;
  }
  .loading-wrap {
    flex-shrink: 0;
    position: absolute;
    z-index: 1;
    width: 512px;
    height: 512px;
    padding-bottom: 50px;
    background-color: #181f26;
    border-radius: 12px;
    .countdown-text {
      font-size: 25px;
      color: #88929f;
    }
  }
  .loading-text {
    color: #ffffff;
    font-size: 11px;
    text-align: center;
  }
  .upload-wrap {
    flex-shrink: 0;
    width: 512px;
    height: 512px;
    border-radius: 12px;
    background: url('~@/assets/images/icon/upload-bg.png') no-repeat;
    background-size: 50%;
    background-position: center 40%;
    background-color: #181f26;
    ::v-deep {
      .el-upload.el-upload--text {
        width: 100%;
        height: 100%;
        opacity: 0;
      }
      .el-upload-dragger {
        width: 100%;
        height: 100%;
      }
    }
  }
  .fabric-wrap {
    flex-shrink: 0;
    position: relative;
    width: 512px;
    height: 512px;
    border-radius: 12px;
    background-color: #181f26;
    // border: 1px solid #fff;
    overflow: hidden;
    .mask {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
      background: rgba($color: #000000, $alpha: 0.7);
    }
    .countdown-text {
      font-size: 25px;
      color: #ffffff;
    }
    .preview-img {
      position: absolute;
      top: 0;
      max-width: 100%;
    }
  }
  .back-btn {
    position: absolute;
    bottom: 40px;
    width: 120px;
    height: 28px;
    line-height: 28px;
    background: #181f26;
    border-radius: 12px;
    color: #9eff0c;
    text-align: center;
    cursor: pointer;
  }
}
.result-wrap {
  position: relative;
  width: 8%;
  height: 600px;
  padding: 1rem;
  // border: 1px solid #ececec;
  border-radius: 12px;
  background: linear-gradient(180deg, #181f26 0%, rgba(24, 31, 38, 0) 100%);
  .preview-wrap {
    width: 75%;
    height: 100%;
  }
  .stage-wrap {
    width: 100%;
    height: 100%;
    overflow: auto;
    .thumbnail-wrap {
      position: relative;
      width: 100%;
      height: 0;
      padding-top: 100%;
      .thumbnail {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border-radius: 10px;
        overflow: hidden;
        &.checked {
          border: 2px solid #9eff0c;
        }
      }
      .download {
        position: absolute;
        left: 50%;
        bottom: 5%;
        width: 30px;
        height: 16px;
        background: url('~@/assets/images/icon/download.png') no-repeat center;
        background-size: 12px;
        background-color: rgba($color: #000000, $alpha: 0.6);
        border-radius: 8px;
        cursor: pointer;
        transform: translateX(-50%);
      }
      .remove {
        position: absolute;
        right: 20%;
        bottom: 5%;
        width: 30px;
        height: 16px;
        background: url('~@/assets/images/icon/remove.png') no-repeat center;
        background-size: 12px;
        background-color: rgba($color: #000000, $alpha: 0.6);
        border-radius: 8px;
        cursor: pointer;
      }
    }
  }
  .save-btn {
    position: absolute;
    top: 760px;
    right: 0;
  }
}
canvas {
  image-rendering: pixelated;
}
</style>
